import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogPuaService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description log
   * @params body
   * @params param
   */
  postLogs(body: any, param: string): Observable<ArrayBuffer> {
    // const httpOptions: NgxHttpClientExtraOptions = {
    //   headers: new HttpHeaders()
    //     .append('Content-Type', 'application/json')
    // };

    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
        .append('x-api-key', environment.apikey)
    };

    const obj: any = { descripcion: param };
    headerConfig.params = new HttpParams({ fromObject: obj });

    return this.http.post(
      environment.endpoints.urlBase +
      environment.endpoints.log.name,
      body,
      // httpOptions
      headerConfig
    );
  }
}
